import { Injectable, Optional } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest } from '@angular/common/http';
import { from, Observable, throwError } from 'rxjs';
import { MsalService } from '@azure/msal-angular';
import { environment } from '../../../environments/environment';
import { catchError, switchMap } from 'rxjs/operators';

@Injectable({providedIn: 'root'})
export class TokenInterceptor implements HttpInterceptor {

    constructor(@Optional() private msalService: MsalService) {
    }
    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        const isApiRequest = /^\[api]/i.test(req.url);
        const isCloud = environment['authMode'] === 'cloud';
        if (!isCloud) {
            const token = localStorage.getItem('token');
            if (!token || !isApiRequest) {
                return next.handle(req);
            }
            const newReq = req.clone({
                setHeaders: { Authorization: `Bearer ${token}` }
            });
            return next.handle(newReq);
        }

        const account = this.msalService.instance.getActiveAccount();
        if (!account) {
            return next.handle(req); // Ikke logget ind
        }

        return from(
            this.msalService.instance.acquireTokenSilent({
                account,
                scopes: environment['apiConfig']?.['scopes'] || [],
            })
        ).pipe(
            switchMap((result) => {
                if (!result.accessToken || !isApiRequest) {
                    return next.handle(req);
                }
                const newReq = req.clone({
                    setHeaders: {
                        Authorization: `Bearer ${result.accessToken}`,
                    },
                });
                return next.handle(newReq);
            }),
            catchError((error) => {
                if (error.name === 'InteractionRequiredAuthError') {
                    this.msalService.instance.acquireTokenRedirect({
                        scopes: environment['apiConfig']?.['scopes'] || [],
                    });
                }
                return throwError(error);
            })

        );
    }

}
